<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>widgets</mat-icon>
        </button>
        <span>{{typename}} anpassen</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">
        <div class="headline">
            Allgemein
        </div>

        <div class="general-settings-wrapper">

            <div>

                <div *ngFor="let setting of generalSettings" class="option" [ngClass]="setting.cssClass" (click)="do(setting.action)">
                    {{setting.title}}
                </div>
            
            </div>

            <div class="refresh-minutes-wrapper">

                <div class="small-headline">Automatisch erneuern</div>
                <mat-form-field class="auto-refresh-minutes" appearance="outline">
                    <input matInput type="number" placeholder="Alle n Minuten" min=1 max=60 [formControl]="refreshMinutesControl" />
                </mat-form-field>

            </div>

        </div>

        <div class="headline">
            Position der Toolbar
        </div>
        <div *ngFor="let position of toolbarPositions" class="slide-toggle-wrapper" (click)="setToolbarPosition(position.value)">
            <mat-slide-toggle [checked]="widgetService.widgetBarPosition === position.value"></mat-slide-toggle>
            <span class="text">
                {{position.title}}
            </span>
        </div>
        <div *ngIf="showUserFilterOption" class="headline">
            Nutzerfilter
            <span class="counter">{{userFilters.length}}</span>
            <button mat-button matSuffix mat-icon-button matTooltip="Hinzufügen" (click)="addUserFilter()" class="icon success">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <ng-container *ngIf="showUserFilterOption">
            <div *ngFor="let userFilter of userFilters" class="entry">
                <button mat-button color="primary" matSuffix mat-icon-button matTooltip="Nutzerfilter bearbeiten" (click)="editUserFilter(userFilter)">
                    <mat-icon>edit</mat-icon>
                </button>
                <span class="text">{{userFilter.filtertext}}</span>
                <button mat-button matSuffix mat-icon-button matTooltip="Löschen" class="icon delete" (click)="deleteUserFilter(userFilter)">
                    <mat-icon>delete_forever</mat-icon>
                </button>
            </div>
        </ng-container>
        <div class="headline" *ngIf="showRoleFilterOption">
            Rollenfilter
            <span class="counter">{{roleFilters.length}}</span>
        </div>

        <ng-container *ngIf="hasChartViews">

            <div class="headline">
                Diagrammansichten
                <span class="counter">{{widgetService.chartViews.length}}</span>
            </div>
            <div class="sub-headline">
                <span>Aus Nextcloud Datei (.json)</span>
                <button mat-button matSuffix mat-icon-button matTooltip="Hinzufügen" (click)="addCustomChartView()" class="icon success">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <div *ngFor="let chart of chartViews" class="entry">
                <button mat-button color="primary" matSuffix mat-icon-button matTooltip="Andere Datei wählen" (click)="changeExistingChartView(chart)">
                    <mat-icon>compare_arrows</mat-icon>
                </button>
                <span class="text">{{chart.name}}</span>
                <button mat-button matSuffix mat-icon-button matTooltip="Löschen" (click)="deleteChartView(chart)" class="icon delete">
                    <mat-icon>delete_forever</mat-icon>
                </button>
            </div>
            
        </ng-container>

        <ng-container *ngIf="iFrameSupport">

            <div class="headline">
                Eingebettete IFrames
                <span class="counter">{{widgetService.iFrameViews.length}}</span>
            </div>
    
            <mat-form-field appearance="outline" class="iframe-url-control">
                <mat-label>Url angeben</mat-label>
                <input matInput type="text" placeholder="Url angeben" [formControl]="iFrameControl" (keyup.enter)="addIFrame()"/>
            </mat-form-field>
    
            <div *ngFor="let url of widgetService.iFrameViews" class="iframe-wrapper">
    
                <span class="text">{{url}}</span>
                <button mat-icon-button  matTooltip="Löschen" (click)="deleteIFrame(url)" class="icon delete">
                    <mat-icon class="delete">delete_forever</mat-icon>
                </button>
    
            </div>

        </ng-container>
    
    </div>
</div>